import { Box, makeStyles } from "@material-ui/core";
import React from "react";

import { layoutTokens, semanticColors as colors } from "@/designTokens";
import theme from "@/theme";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: layoutTokens.space[12],
    [theme.breakpoints.up("md")]: { gap: 0 },
  },
  card: {
    padding: layoutTokens.space[16],
    background: colors["surface/card"],
    borderRadius: layoutTokens.radius.lg,
    [theme.breakpoints.up("md")]: {
      padding: "16px 20px",
      borderRadius: 0,
      borderBottom: `1px solid ${colors["border/default"]}`,
    },
  },
  who: { display: "flex", alignItems: "center", gap: layoutTokens.space[12], marginBottom: layoutTokens.space[12] },
  avatar: {
    width: 44,
    height: 44,
    flexShrink: 0,
    borderRadius: layoutTokens.radius.full,
    background: colors["field/bg"],
    [theme.breakpoints.up("md")]: { width: 40, height: 40 },
  },
  names: { flex: 1 },
  line: {
    height: 21,
    borderRadius: layoutTokens.radius.sm,
    background: colors["field/bg"],
    marginBottom: layoutTokens.space[8],
  },
  detail: {
    background: colors["surface/card"],
    borderRadius: layoutTokens.radius.lg,
    padding: layoutTokens.space[24],
    minHeight: 520,
    [theme.breakpoints.up("md")]: { padding: layoutTokens.space[32], minHeight: 400 },
  },
  block: { height: 150, background: colors["field/bg"], borderRadius: layoutTokens.radius.md, margin: "24px 0" },
});

export const MessageSkeleton: React.FC<{ detail?: boolean }> = ({ detail = false }) => {
  const classes = useStyles();
  return (
    <Box
      role="status"
      aria-label="メッセージを読み込んでいます"
      data-testid="loading"
      className={detail ? classes.detail : classes.root}
    >
      {detail ? (
        <>
          <Box className={classes.who}>
            <Box className={classes.avatar} />
            <Box className={classes.names}>
              <Box className={classes.line} width="40%" />
              <Box className={classes.line} width="60%" />
            </Box>
          </Box>
          <Box className={classes.block} />
          {[100, 80, 100, 60, 90].map((width, i) => (
            <Box key={i} className={classes.line} width={`${width}%`} />
          ))}
        </>
      ) : (
        [0, 1, 2, 3].map((i) => (
          <Box key={i} className={classes.card}>
            <Box className={classes.who}>
              <Box className={classes.avatar} />
              <Box className={classes.names}>
                <Box className={classes.line} width={120} />
                <Box className={classes.line} width={90} />
              </Box>
            </Box>
            <Box className={classes.line} />
            <Box className={classes.line} width="60%" />
          </Box>
        ))
      )}
    </Box>
  );
};
